import { css } from 'linaria';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  margin-bottom: var(--space-650);
`;

export const wrapper = css`
  position: relative;
`;

export const containerPhoto = css`
  display: grid;
  grid-auto-flow: column;
  gap: var(--space-100);
  /* grid-auto-columns: minmax(18%, 205px); */
  grid-auto-columns: minmax(max-content, 205px);

  overflow-x: auto;
  overscroll-behavior-inline: contain;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`;

export const nothingFound = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: var(--space-200);
`;

export const showReviewPhotoBtn = css`
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
`;

export const imgStyles = css`
  display: block;
  width: 100%;
  height: 160px;
  object-fit: cover;
  cursor: pointer;
  border-radius: var(--space-50);
  max-width: 205px;
  min-width: 122px;
`;

export const arrowRight = css`
  position: absolute;
  left: 100%;
  top: 50%;
  display: flex;
  justify-content: center;
  z-index: 1;
  width: 40px;
  height: 40px;
  background-color: var(--control-invert);
  box-shadow: var(--box-shadow-m);
  transform: translateX(-50%) translateY(-50%);
  transition: opacity 0.2s ease 0s;
  cursor: pointer;
  border-radius: 50%;
  @media (--to-tablet) {
    display: none;
  }
  &:hover {
    background-color: var(--control-invert);
  }
`;

export const arrowLeft = css`
  position: absolute;
  left: 0%;
  top: 50%;
  display: flex;
  justify-content: center;
  z-index: 1;
  width: 40px;
  height: 40px;
  background-color: var(--control-invert);
  box-shadow: var(--box-shadow-m);
  transform: translateX(-50%) translateY(-50%);
  transition: opacity 0.2s ease 0s;
  cursor: pointer;
  border-radius: 50%;

  @media (--to-tablet) {
    display: none;
  }

  &:hover {
    background-color: var(--control-invert);
  }
`;
